import { render, staticRenderFns } from "./AppSearch.vue?vue&type=template&id=60f10916&scoped=true"
import script from "./AppSearch.vue?vue&type=script&lang=js"
export * from "./AppSearch.vue?vue&type=script&lang=js"
import style0 from "./AppSearch.vue?vue&type=style&index=0&id=60f10916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f10916",
  null
  
)

export default component.exports